import React from "react";
import * as Icons from "lucide-react";
import ScrollReveal from "./ScrollReveal";
import { SERVICES } from "../lib/siteData";

export const ServiceCard = ({ service, index }) => {
  const Icon = Icons[service.icon] || Icons.Sparkle;
  return (
    <ScrollReveal delay={index * 0.08}>
      <article
        data-testid={`service-card-${service.key}`}
        className="group bg-white border border-[#E5E5DF] hover:border-[#D4AF37] transition-colors duration-500 overflow-hidden h-full flex flex-col"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F5F0]">
          <img
            src={service.image}
            alt={service.title}
            loading="lazy"
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-[1.04] transition-all duration-[900ms] ease-out"
          />
          <div className="absolute top-5 left-5 w-11 h-11 bg-[#1A1D20] group-hover:bg-[#D4AF37] transition-colors duration-300 flex items-center justify-center">
            <Icon size={20} strokeWidth={1.5} color="#FCFCFA" />
          </div>
        </div>
        <div className="p-8 flex-1 flex flex-col">
          <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A1D20] leading-tight">
            {service.title}
          </h3>
          <p className="mt-4 text-[14px] leading-relaxed text-[#5C636A] flex-1">
            {service.summary}
          </p>
          <div className="mt-6 inline-flex items-center gap-3">
            <span className="h-[1px] w-8 bg-[#D4AF37] group-hover:w-14 transition-all duration-500" />
            <span className="uppercase tracking-[0.2em] text-[11px] font-semibold text-[#1A1D20]">
              Learn More
            </span>
          </div>
        </div>
      </article>
    </ScrollReveal>
  );
};

export const ServicesGrid = ({ title = true }) => {
  return (
    <section
      data-testid="services-section"
      className="bg-[#FCFCFA] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {title && (
          <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-24">
            <div className="md:col-span-5">
              <div className="flex items-center gap-4 mb-6">
                <span className="hairline-gold" />
                <span className="overline">Our Services</span>
              </div>
              <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-[#1A1D20]">
                Six pillars,<br />one integrated city.
              </h2>
            </div>
            <div className="md:col-span-6 md:col-start-7 flex items-end">
              <p className="text-[#5C636A] text-[15px] md:text-[17px] leading-relaxed">
                Every sector of the Cape Maclear SEZ is engineered to reinforce
                the others — creating compounding economic, social and
                environmental returns for investors, residents and the region.
              </p>
            </div>
          </div>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.key} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
